var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 9.5C12.4832 9.5 12.875 9.84691 12.875 10.2748V16.4351C12.875 16.8631 12.4832 17.21 12 17.21C11.5168 17.21 11.125 16.8631 11.125 16.4352V10.2749C11.125 9.84691 11.5168 9.5 12 9.5ZM13.0435 7.47829C13.0435 8.05459 12.5763 8.52177 12 8.52177C11.4237 8.52177 10.9565 8.05459 10.9565 7.47829C10.9565 6.902 11.4237 6.43481 12 6.43481C12.5763 6.43481 13.0435 6.902 13.0435 7.47829Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidInfo);
export default __webpack_public_path__ + "static/media/solid-info.85cab532a78882a3aead1a289062e1b8.svg";
export { ForwardRef as ReactComponent };